import { render, staticRenderFns } from "./AboutInfoReview.vue?vue&type=template&id=0c5cf87c"
import script from "./AboutInfoReview.vue?vue&type=script&lang=js"
export * from "./AboutInfoReview.vue?vue&type=script&lang=js"
import style0 from "./AboutInfoReview.vue?vue&type=style&index=0&id=0c5cf87c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports